
const Shimmer = ({ className }: { className?: string }) => {
  return (
    <div 
      className={`animate-pulse rounded
        bg-gradient-to-r from-muted via-muted/80 to-muted/50
        dark:from-white/10 dark:via-white/5 dark:to-white/10
        ocean:from-blue-800/40 ocean:via-blue-700/30 ocean:to-blue-800/40
        sunset:from-orange-800/40 sunset:via-orange-700/30 sunset:to-orange-800/40
        forest:from-green-800/40 forest:via-green-700/30 forest:to-green-800/40
        transition-colors duration-300
        ${className}`} 
    />
  );
};

export default Shimmer;
